export const formatMoney = (price: number) =>
  price.toLocaleString('en-GB', {
    style: 'currency',
    currency: 'GBP'
  })

export const sanitizeNumber = (value?: string | number) => {
  if (!value) return Number(0)
  if (typeof value === 'string') return parseFloat(value)
  return value
}
